import gql from 'graphql-tag';

export const sharedPlaceFragment = gql`
  fragment sharedPlaceParts on SharedPlace {
    id
    name
    serializedParams
  }
`;
